import "./DocsGrid.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";

import { CaseDocumentWithPresignedUrl } from "pwapi";

import { openDocument } from "shared/actions/caseDetailActions";
import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import LinkButton from "components/LinkButton";
import useViewerDocuments from "hooks/useViewerDocuments";

import DocsListItem from "./DocsListItem";

interface DocsGridProps {
  caseDetail: CaseDetailState;
}

//Slide Viewer uses this
//TODO: either move this or deprecate it
export const OldItem = ({
  caseDetail,
  document,
}: {
  caseDetail: CaseDetailState;
  document: CaseDocumentWithPresignedUrl;
}) => {
  const dispatch = useDispatch();

  return (
    <li>
      <div className="DocsLineItem">
        <LinkButton
          nocolor
          disabled={caseDetail?.deadDocIds.indexOf(document.id || 0) !== -1}
          onClick={() => {
            caseDetail.id &&
              dispatch(openDocument(caseDetail.id, document.id || 0));
          }}
        >
          {document.wpl_document_metadata &&
          Object.keys(document.wpl_document_metadata)?.length ? (
            <strong>
              {document.wpl_document_metadata.type}
              {document.wpl_document_metadata.type !==
                document.wpl_document_metadata.comment &&
                document.wpl_document_metadata.comment && (
                  <> {document.wpl_document_metadata.comment}</>
                )}
            </strong>
          ) : (
            <strong>{document.name?.replace(".pdf", "")}</strong>
          )}
          &nbsp;&ndash;&nbsp;
          <span>
            {new Date(document.created_at || "").toLocaleDateString()}
          </span>
        </LinkButton>
      </div>
    </li>
  );
};

const DocsGrid = ({ caseDetail }: DocsGridProps) => {
  const { requisitionForm, otherDocuments } = useViewerDocuments(caseDetail);

  const is_diagnostic = caseDetail.accession_prefix?.is_diagnostic;

  return (
    <div className="DocsGrid">
      <span className="Documents">
        Documents{" "}
        <span style={{ opacity: 0.6 }}>({otherDocuments.length})</span>{" "}
        {!requisitionForm && is_diagnostic && (
          <FontAwesomeIcon icon="exclamation-circle" color="var(--red)" />
        )}{" "}
        <strong style={{ fontSize: "larger" }}>▾</strong>
        <ul>
          {!requisitionForm && is_diagnostic && (
            <li className="Documents__missing">
              <FontAwesomeIcon icon="exclamation-circle" color="var(--red)" />{" "}
              Missing Requisition Form
            </li>
          )}
          {otherDocuments.map((document, index) => (
            <DocsListItem
              key={`${document.name}${index}`}
              document={document}
              caseDetail={caseDetail}
            />
          ))}
        </ul>
      </span>
    </div>
  );
};

export default DocsGrid;
